import { BehaviorSubject } from 'rxjs';

export const networkStatus$ = new BehaviorSubject<boolean>(true);
